import { BaseProxy, type ProxyMethods } from '@/proxies/Proxy'

export default class PickupProxy extends BaseProxy implements ProxyMethods {
  public endpoint = 'pickup'

  getPickupDates(countryCode?: string) {
    const q = countryCode ? `?countryCode=${countryCode}` : ''
    return this.submit('get', `/${this.endpoint}/dates${q}`)
  }
}
